// extracted by mini-css-extract-plugin
export var menuIcon = "_nt-0";
export var menuIconInline = "_nt-1";